(function ($, undefined) {
    'use strict';

    var $doc = $(document),
        $win = $(window);

    var pluginName     = 'popelRowslider';
    var pluginDefaults = {
        rowClass:          'rowslider-row',
        activeClass:       'rowslider-active',
        arrowVisibleClass: 'rowslider-visible',
        arrowLeftClass:    'rowslider-arrow-block-left',
        arrowRightClass:   'rowslider-arrow-block-right',

        transitionDuration: 500
    };


    // Helpers
    // -------
    var _toCamelCase = function(str) {
        return str.replace(/-([a-z])/g, function ($0, $1) {
            return $1.toUpperCase();
        }).replace('-', '');
    };

    var _cssPrefix = (function () {
        var _cache = {};

        return function (property) {
            var _prop = _toCamelCase(property);

            if (!(_prop in _cache)) {
                var element = document.createElement('div'),
                    prefixes = ['', 'Moz', 'Webkit', 'O', 'ms', 'Khtml'];

                for (var i in prefixes) {
                    if (element.style[prefixes[i] + _prop] !== undefined) {
                        return (_cache[_prop] = prefixes[i] + _prop);
                    }
                }
            }

            return _cache[_prop];
        };
    })();


    // Constructor
    // -----------
    var Rowslider = function (element, options) {
        this.$element = $(element).attr('data-toggle', 'popel-rowslider');
        this.options  = options;

        _initActiveElement.call(this);
        _updateRowOffset.call(this, true);
        _updateArrows.call(this);
    };


    // Private methods
    // ---------------
    var _initActiveElement = function () {
        var $row    = this.$element.find('.' + this.options.rowClass),
            $cols   = $row.find('> *'),
            $active = $cols.filter('.' + this.options.activeClass).first();

        if (!$active || !$active.length) {
            $active = $cols.first().addClass(this.options.activeClass);
        }

        $cols.not($active).removeClass(this.options.activeClass);
    };

    var _updateActiveElement = function (active) {
        var $row    = this.$element.find('.' + this.options.rowClass),
            $cols   = $row.find('> *'),
            $active = $(active);

        if (!$active || !$active.length) return;

        $active.addClass(this.options.activeClass);
        $cols.not($active).removeClass(this.options.activeClass);

        $row[0].offsetWidth; // force reflow
    };

    var _updateRowOffset = function (noTransition) {
        var $row    = this.$element.find('.' + this.options.rowClass),
            $cols   = $row.find('> *'),
            $active = $cols.filter('.' + this.options.activeClass).first(),
            offset  = $active.position().left;

        if (noTransition) {
            $row.css('transition', 'none');

            $row[0].offsetWidth; // force reflow
        }

        $row.css(
            _cssPrefix('transform'),
            offset > 0 ? 'translateX(-' + offset + 'px)' : ''
        )

        $row[0].offsetWidth;
        $row.css('transition', '');
    };

    var _updateArrows = function () {
        var $left     = this.$element.find('.' + this.options.arrowLeftClass),
            $right    = this.$element.find('.' + this.options.arrowRightClass),
            $row      = this.$element.find('.' + this.options.rowClass),
            $cols     = $row.find('> *'),
            $active   = $cols.filter('.' + this.options.activeClass),
            $last     = $cols.last(),
            width     = $row.width(),
            offset    = $active.position().left,
            lastWidth = Math.round($last.outerWidth(true)),
            lastLeft  = $last.position().left,
            maxOffset = lastLeft + lastWidth - width;

        $left[(offset > 0 ? 'add' : 'remove') + 'Class'](this.options.arrowVisibleClass);
        $right[(offset < maxOffset ? 'add' : 'remove') + 'Class'](this.options.arrowVisibleClass);
    };

    var _getItemForDirection = function (type, row, active) {
        var $row        = $(row),
            $cols       = $row.find('> *'),
            $active     = $(active),
            width       = $row.width(),
            activeIndex = $cols.index($active),
            left        = $active.position().left,
            right       = left + width,
            colLength   = $cols.length,
            minLeft     = left - width,
            $next,
            $col,
            nextIndex,
            edgeIndex,
            i,
            j,
            calcWidth,
            colWidth,
            colLeft,
            colRight;

        if (type == 'prev') {
            if (activeIndex <= 0) return false;

            // Slide to right (reveal prev elements)
            nextIndex = activeIndex - 1;

            $next     = $cols.eq(nextIndex);
            edgeIndex = nextIndex;

            // Find first element fully inside future viewport
            for (i = 0; i <= nextIndex; i++) {
                $col     = $cols.eq(i),
                colWidth = Math.round($col.outerWidth(true));
                colLeft  = $col.position().left;
                colRight = colLeft + colWidth;

                if (colLeft >= minLeft) {
                    edgeIndex = i;
                    break;
                }
            }

            // Find perfect viewport fit element
            for (i = edgeIndex; i <= nextIndex; i++) {
                calcWidth = 0;

                for (j = i; j < colLength; j++) {
                    $col       = $cols.eq(j);
                    colWidth   = Math.round($col.outerWidth(true));
                    calcWidth += colWidth;

                    if (calcWidth == width) return $cols.eq(i);
                    else if (calcWidth > width) break;
                }
            }

            return $next;
        } else {
            if (activeIndex >= colLength - 1) return false;

            // Slide to left (reveal next elements)
            nextIndex = activeIndex + 1;

            $next     = $cols.eq(nextIndex);
            edgeIndex = nextIndex;

            // Find first element partially or fully outside viewport
            for (i = nextIndex; i < colLength; i++) {
                $col     = $cols.eq(i);
                colWidth = Math.round($col.outerWidth(true));
                colLeft  = $col.position().left;
                colRight = colLeft + colWidth;

                if (colLeft <= right && colRight > right) {
                    edgeIndex = i;
                    break;
                }
            }

            // Find perfect viewport fit element
            for (i = edgeIndex; i >= nextIndex; i--) {
                calcWidth = 0;

                for (j = i; j < colLength; j++) {
                    $col       = $cols.eq(j);
                    colWidth   = Math.round($col.outerWidth(true));
                    calcWidth += colWidth;

                    if (calcWidth == width) return $cols.eq(i);
                    else if (calcWidth > width) break;
                }
            }

            return $next;
        }
    };


    // Public methods
    // --------------
    Rowslider.prototype.resize = function () {
        _updateRowOffset.call(this, true);
        _updateArrows.call(this);
        return this;
    };

    Rowslider.prototype.next = function () {
        if (this.sliding) return;
        return this.slide('next');
    };

    Rowslider.prototype.prev = function () {
        if (this.sliding) return;
        return this.slide('prev');
    };

    Rowslider.prototype.slide = function (type) {
        if (this.sliding) return;

        var $row      = this.$element.find('.' + this.options.rowClass),
            direction = type == 'next' ? 'left' : 'right',
            $active   = $row.find('.' + this.options.activeClass),
            $next     = _getItemForDirection.call(this, type, $row, $active),
            self      = this;

        if (!$next || !$next.length) return (this.sliding = false);
        if ($next.hasClass(this.options.activeClass)) return (this.sliding = false);

        var relatedTarget = $next[0];
        var slideEvent    = $.Event('slide.popel.rowslider', {
            relatedTarget: relatedTarget,
            direction:     direction
        });

        this.$element.trigger(slideEvent);

        if (slideEvent.isDefaultPrevented()) return;

        this.sliding = true;

        var slidEvent = $.Event('slid.popel.rowslider', {
            relatedTarget: relatedTarget,
            direction:     direction
        });

        var offset = $next.position().left;

        if ($.support.transition) {
            _updateActiveElement.call(this, $next);
            _updateRowOffset.call(this);
            _updateArrows.call(this);

            $row.one('bsTransitionEnd', function () {
                self.sliding = false;

                setTimeout(function () {
                    self.$element.trigger(slidEvent);
                }, 0);
            }).emulateTransitionEnd(this.options.transitionDuration);
        } else {
            _updateActiveElement.call(this, $next);
            _updateRowOffset.call(this, true);
            _updateArrows.call(this);

            this.sliding = false;

            this.$element.trigger(slidEvent);
        }

        return this;
    };


    var Plugin = function (option) {
        return this.each(function () {
            var $this   = $(this),
                data    = $this.data('popel.rowslider'),
                options = $.extend({}, pluginDefaults, $this.data(), typeof option == 'object' && option),
                action  = typeof option == 'string' ? option : options.slide;

            if (!data) $this.data('popel.rowslider', (data = new Rowslider(this, options)));
            if (action) data[action]();
        });
    };

    $.fn[pluginName]             = Plugin;
    $.fn[pluginName].Constructor = Rowslider;
    $.fn[pluginName].defaults    = pluginDefaults;


    $doc.on('click.popel.rowslider', '[data-slide]', function (event) {
        event.preventDefault();

        var $this   = $(this),
            href    = $this.attr('href').replace(/.*(?=#[^\s]+$)/, ''),
            target  = $this.attr('data-target') || (href != '#' && href),
            $target = target ? $(target) : $this.closest('[data-toggle="popel-rowslider"]');

        if (!$target || !$target.length) return;

        var options = $.extend({}, $target.data(), $this.data());

        Plugin.call($target, options);
    });

    $win.on('resize.popel.rowslider', function () {
        $('[data-toggle="popel-rowslider"]')[pluginName]('resize');
    });

    $(function () {
        $('[data-toggle="popel-rowslider"]')[pluginName]();
    });
})(window.jQuery);
